export var paymentPlansBaseUrl = 'v1/credit/account/payment-plans';
export var settlementEligibilityCheckUrl = "".concat(paymentPlansBaseUrl, "/settlement");
export var settlementQuestionnaireUrl = "".concat(settlementEligibilityCheckUrl, "/questionnaire");
var planBaseUrl = 'v1/credit/accounts/payment-plans/customer-assistance-plan';
export var planEligibilityCheckUrl = "".concat(planBaseUrl, "/precheck");
export var planQuestionnaireUrl = "".concat(planBaseUrl, "/questionnaire");
export var planQuestionnaireEligibilityUrl = "".concat(planBaseUrl, "/eligibility");
export var planEnrollmentUrl = "".concat(planBaseUrl, "/enrollment");
var paymentsBaseUrl = 'v1/credit/billing/payments';
export var autopayEnrollUrl = "".concat(paymentsBaseUrl, "/autopay");
//# sourceMappingURL=api-endpoints.js.map